define('lq/dropSortable',[
    'jquery',
    'sortable'
], function ($, Sortable) {
    'use strict';

    return {
        setUpSortable: function (conf) {
            Sortable.create(conf.$element[0], {
                animation: conf.animation,
                ghostClass: conf.ghostClass,
                forceFallback: conf.forceFallback,
                scroll: conf.scrolling,
                scrollSensitivity: conf.scrollSensitivity,
                scrollSpeed: conf.scrollSpeed,
                handle: conf.handle,
                onStart: function (evt) {
                    var id = $(evt.item).data('id');
                    conf.drop.triggerEventIfEnabled('dragStart', id);

                    $('.sortable-fallback').css('opacity', '');
                },
                onMove: function (evt) {
                    return evt.related.matches(conf.moveable);
                },
                onEnd: function (evt) {
                    var id = $(evt.item.previousElementSibling).data('id');
                    if (id)
                        conf.drop.triggerEventIfEnabled('dragEnd', id);
                    else
                        conf.drop.triggerEventIfEnabled('dragEnd', undefined);
                }
            });
        }
    };
});

